import { FaRegCheckCircle } from "react-icons/fa";
import aiIcon from "../../../../assets/ai-icon-filled.svg";

import { PLUM_PURPLE_800, SUCCESS_GREEN } from "../../colors";
import FlexBox from "../../FlexBox";
import { Body1, H3 } from "../../Headings";
import { SessionBulletIcon, SessionBulletRow } from "../styles";

const AIChatStep = () => (
  <FlexBox column rowGap="1.5rem">
    <FlexBox align="center" justify="center" columnGap="0.5rem">
      <img src={aiIcon} alt="AI icon" width="32" height="32" />
      <H3 bold color={PLUM_PURPLE_800}>
        AI Chat Assistant
      </H3>
    </FlexBox>
    <FlexBox column rowGap="1rem">
      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          Get <strong>answers to any questions about the clients</strong>, their
          journey, history, or any particular detail about the session.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          Provides{" "}
          <strong>summary of the session or any session details</strong> in
          seconds along with <strong>suggestions to support planning </strong>
          for care treatment.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          Generate <strong>case approaches</strong> (CBT, psychodynamic, etc.)
          along with <strong>psycho-educational explanations</strong> for
          symptoms and disorders.
        </Body1>
      </SessionBulletRow>
    </FlexBox>
  </FlexBox>
);

export default AIChatStep;
